// Pre-Step 4 · Part 4 — the engagement cap on screen. The texts come from the server in EN + AR (engagement_cap / plan_caps):
// a refused copy / roll forward / restore job carries error_code ENGAGEMENT_LIMIT_REACHED, error (EN) and error_ar; removing a
// firm's plan returns message / message_ar ("Plan removed. The firm keeps its current limits: …").
export const CAP_CODE = "ENGAGEMENT_LIMIT_REACHED";

export function capJobText(job, lang) {
  if (!job || job.error_code !== CAP_CODE) return "";
  return (lang === "ar" && job.error_ar) || job.error || "";
}

export function planChangeNote(data, lang) {
  if (!data || !data.message) return "";
  return (lang === "ar" && data.message_ar) || data.message;
}
